module.exports = __webpack_public_path__ + "images/emoji/pig_nose.b47894cb7017feae1939.png";